import React, { Component } from "react";

import AppContext from "./AppContext";

class Check extends Component {
  static contextType = AppContext;

  render() {
    const { QUIZ } = this.context;
    return (
      <section className="section">
        <div className="container content">
          {QUIZ.map((r, i) => (
            <div className="level level-item" key={i}>
              <article className="message result check">
                <div className="message-body">
                  <div className="is-size-5">📖 {r.title}</div>
                  {r.variants.map((v, k) => (
                    <div className="is-size-6" key={k}>
                      {v.correct === true ? "✅" : "🏷️"}&nbsp;{v.title}
                    </div>
                  ))}
                  <div className="is-size-6">
                    <div className="notification is-warning theory">
                      {QUIZ[i].theory.split("\n").map((item, key) => {
                        return <div key={key}>{item}</div>;
                      })}
                    </div>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </section>
    );
  }
}

export default Check;
